import React from "react";
import i18n from "../i18n";

const Input = ({
  type,
  label,
  placeholder,
  value,
  onChange,
  leftIcon,
  rightIcon,
  disabled,
  className,
  borderColor,
  onBlur,
  tooltipContent,
  labelicon,
  tooltipClassName,
  ...rest
}) => {
  const isRTL = () => {
    const rtlLanguages = ["ar", "fa", "ur"];
    return rtlLanguages.includes(i18n.language);
  };
  return (
    <div className="relative w-full flex justify-end">
      <div
        className={` sm:h-[36px] h-[32px] ${
          disabled ? "bg-primary-bg border text-gray border-primary-bg " : "  "
        } border ${
          borderColor || "border-primary"
        } border-opacity-50 flex items-center py-[7.5px] rounded-[6px] focus:outline-none ${
          label ? "sm:mt-[12px] mt-[10px]" : "mt-0"
        } px-[8px] sm:px-[12px] ${className}`}
      >
        {leftIcon && (
          <div className=" ">
            <p
              className={`${
                borderColor || "border-primary"
              } ${isRTL() ? "border-l pl-[8px]" : "border-r pr-[8px]"} sm:text-[16px] text-[14px] text-[#747878] font-lato-regular-400 `}
            >
              {leftIcon}
            </p>
          </div>
        )}
        <input
          labelicon={labelicon}
          type={type}
          autoComplete="off"
          id={label}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          onBlur={onBlur}
          className={`block w-full  ${isRTL() ? "sm:pr-[7px] pr-[6px] direction-rtl" : "direction-ltr sm:pl-[7px] pl-[6px]"} focus:outline-none bg-[transparent] text-sm sm:text-[15px]`}
          {...rest}
        />
        {rightIcon && (
          <div className="">
            <p
              className={`border-l  ${
                borderColor || "border-primary"
              } pl-[8px] sm:text-[16px] text-[14px] text-black font-lato-regular-400`}
            >
              {rightIcon}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Input;
